import { InView } from 'react-intersection-observer';
import style from '../knear.module.scss'
import animations from '@styles/animations.module.scss'

interface TextSectionProps{
    title:string;
    text: Array<string>
}

const TextSection = ({title, text}:TextSectionProps) => {
    return (
        <section className={`${style.section}`}>
                <div className={`${style.container}`}>
                    <div className={`${style.container__flex}`}>
                        <InView triggerOnce={true}>
                            {({ inView, ref, entry }: any) => {
                                if (inView) {
                                    entry?.target.classList.add(animations.active);
                                }
                                return (
                                    <div ref={ref} className={`${style.container__list__title} ${style.container__title} ${style.container__title_left} ${animations.scroll__animation}`}>
                                        {title}
                                    </div>
                                )
                            }}
                        </InView>
                        <div className={`${style.container__list}`}>
                            {text.map((item: any, index: number) => {
                                return (
                                    <InView key={index} triggerOnce={true}>
                                        {({ inView, ref, entry }: any) => {
                                            if (inView) {
                                                entry?.target.classList.add(animations.active);
                                            }
                                            return (
                                                <div ref={ref} className={`${style.container__text_small} ${animations.scroll__animation}`}>
                                                    {item}
                                                </div>
                                            )
                                        }}
                                    </InView>
                                )
                            })}
                        </div>

                    </div>
                </div>
            </section>
    )
}

export default TextSection;